import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { APRIL_2026_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(APRIL_2026_CAMPAIGN_END_DATE);
